<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <h4 class="text-center mb-3 mt-3">
        <span class="custom-Roboto custom-weight-500 custom-font-30">{{ "HOT_CALLS_QUEUE" | translate }}</span>
      </h4>
      <!-- Active hot call -->
      <div
        class="d-flex col-10 col-md-10 mx-auto tiles border-tiles-active rounded align-items-center mb-3 card-shape cu"
        (click)="routeActiveHotCall()">
        <div class="active-tile left-peek"></div>

        <div class="flex-grow-1 px-1 px-md-3 bg-white h-100 d-flex align-items-center fon">
          <span class="tile-text mb-0">{{ "ACTIVE_HOT_CALLS" | translate }}</span>
        </div>

        <div class="text-dark d-flex justify-content-center align-items-center rounded-end right-peek">
          <h2 class="mb-0">{{activeHotCallsCount}}</h2>
        </div>
      </div>

      <!-- Closed hot call  -->
      <div
        class="d-flex col-10 col-md-10 mx-auto tiles border-tiles-close rounded align-items-center mb-3 card-shape cu"
        (click)="routeClosedHotCall()">
        <div class="closed-tile rounded-start left-peek"></div>

        <div class="flex-grow-1 px-1 px-md-3 bg-white h-100 d-flex align-items-center">
          <span class="tile-text-wrapper">
          <p class="tile-text mb-0">{{ "CLOSED_HOT_CALLS" | translate }}</p>
        </span>
        </div>

        <div class="text-dark d-flex justify-content-center align-items-center rounded-end right-peek">
          <h2 class="mb-0">{{closedHotCallsCount}}</h2>
        </div>
      </div>

      <!-- My hot call -->
      <div class="d-flex tiles col-10 col-md-10 mx-auto border-tiles-myhc rounded align-items-center mb-3 card-shape cu"
        (click)="routeMyHotCall()">
        <div class="myhc-tile rounded-start left-peek"></div>

        <div class="flex-grow-1 px-1 px-md-3 bg-white h-100 d-flex align-items-center w-80">
          <p class="tile-text mb-0">{{ "MY_HOT_CALLS" | translate }}</p>
        </div>

        <div class="text-dark d-flex justify-content-center  align-items-center right-peek">
          <h2 class="mb-0">{{ myHotCallCount }}</h2>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button *ngIf="isNewCreateHotCall" class="btn-create-hot-call rounded-pill" (click)="createNewHotCall('new')">
          <span class="custom-Roboto custom-font-24 color-white">{{
            "CREATE_NEW_HOT_CALL" | translate
            }}</span>
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <button *ngIf="!isNewCreateHotCall" class="btn-create-hot-call rounded-pill"
          (click)="createNewHotCall('data available')">
          <span class="custom-Roboto  custom-font-24 color-white">{{
            "GET_RECENT_HOT_CALL" | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
</div>